export const getShops = (state) => state.shops
export const getPosCheckoutStatus = (state) => state.posCheckoutStatus
export const getPosCheckoutDetails = (state) => state.checkoutDetails
export const getDefaultCurrency = (state) => state.defaultCurrency
export const getShopProductSaleElementsByCategories = (state) => state.product_sale_elements_by_categories
export const getShopProductSaleElements = (state) => state.product_sale_elements
export const getShoCategories = (state) => state.categories

export const getShopAlerts = (state) => state.alerts
// au moins une alerte dans une boutique : point rouge du menu Boutiques
export const hasShopAlerts = (state) => Object.values(state.alerts).some(alert => alert.total > 0)
